module.exports = __webpack_public_path__ + "static/media/signature.3a8916ca.svg";